let getQueryString = function (url, name) {
    var reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i')
    var r = url.substr(1).match(reg)
    if (r != null) {
        return r[2]
    }
    return null;
}

//取出数组中某个元素的最大值
let getArrayItemMax = function (array, itemName) {
    let newArr = array.sort(function (a, b) {
        return a[itemName] - b[itemName];
    });
    let maxItem = newArr[newArr.length - 1];
    return maxItem;
}

module.exports = {
    getQueryString: getQueryString,
    getArrayItemMax: getArrayItemMax
}
